import React, { useCallback, useEffect, useMemo, useState } from "react";
import { apiGet } from "../../services/api";
import Button from "../common/Button";

interface CollectionData {
  total?: number;
  bills?: unknown[];
  date?: string;
}

export default function TodayCollectionWidget({ onOpenHistory }: { onOpenHistory?: () => void }) {
  const today = useMemo(() => new Date().toISOString().slice(0, 10), []);
  const [data, setData] = useState<CollectionData>({ total: 0, bills: [], date: today });
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiGet(`/api/pharmacy/collection?date=${today}`);
      const r = res as CollectionData;
      setData({
        total: Number(r?.total || 0),
        bills: Array.isArray(r?.bills) ? r.bills : [],
        date: r?.date || today,
      });
    } catch (e) {
      console.error("Failed to load today's pharmacy collection", e);
      setData({ total: 0, bills: [], date: today });
    } finally {
      setLoading(false);
    }
  }, [today]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const handler = () => load();
    window.addEventListener("pharmacy:billSaved", handler);
    return () => window.removeEventListener("pharmacy:billSaved", handler);
  }, [load]);

  const billsCount = Array.isArray(data.bills) ? data.bills.length : 0;

  return (
    <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', gap: '16px', background: 'linear-gradient(to right, #ffffff, #f1f5f9)' }}>
      <div className="mod-split-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', marginBottom: '4px' }}>Today Collection</div>
          <div style={{ fontSize: '1.75rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', lineHeight: 1.2 }}>₹{Number(data.total || 0).toLocaleString("en-IN")}</div>
          <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '4px' }}>{billsCount} patient bill(s)</div>
        </div>
        <Button variant="outline" size="sm" onClick={load} isLoading={loading} style={{ padding: '6px 10px', fontSize: '1.2rem' }}>
          ↻
        </Button>
      </div>
      <div style={{ paddingTop: '12px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="primary" onClick={() => onOpenHistory?.()} style={{ width: '100%' }}>
          View Sales History
        </Button>
      </div>
    </div>
  );
}

